<section id="features" class="features">
  <div class="container">
    <h2 class="features-title">Key Features</h2>
    <div class="features-grid">
      <div class="feature-card">
        <div class="feature-image">
          <img src="/images/dashboard.png" alt="Overview" />
        </div>
        <h3 class="feature-heading">All-in-one Dashboard</h3>
        <ul class="feature-text">
          <li>Unified orders & customer view</li>
          <li>Sales overview with trends</li>
          <li>Performance KPIs at a glance</li>
          <li>Quick filters and exports</li>
        </ul>
      </div>

      <div class="feature-card">
        <div class="feature-image">
          <img src="/images/dashboard.png" alt="Analytics" />
        </div>
        <h3 class="feature-heading">Real-time Analytics</h3>
        <ul class="feature-text">
          <li>Live dashboards and widgets</li>
          <li>Custom alerts and thresholds</li>
          <li>Deep-dive drill-down reports</li>
          <li>Exportable CSV and PDF</li>
        </ul>
      </div>

      <div class="feature-card">
        <div class="feature-image">
          <img src="/images/support.png" alt="Support" />
        </div>
        <h3 class="feature-heading">24/7 Support</h3>
        <ul class="feature-text">
          <li>Live chat and phone support</li>
          <li>Ticketing with SLA tracking</li>
          <li>Dedicated account manager</li>
          <li>Extensive knowledge base</li>
        </ul>
      </div>
    </div>
  </div>
</section>
